import Vue from 'vue'
import {Notification} from '@models'

let selfDestructTimer = null;

export default {
    state: Vue.observable({
        show: false,
        type: 'warning',
        title: 'Default notification message.',
        text: 'If you\'re seeing this, something went wrong on the Notifications.vue component.',
        useRawText: false,
        useRawTitle: false
    }),

    supportedTypes: ['info', 'success', 'danger', 'warning','bell'],

    show: _.debounce(function (type, title, text, useRawTitle = false, useRawText = false) {
        this.hide()
        this.state.title = title
        this.state.text = text
        this.state.useRawText = useRawText
        this.state.useRawTitle = useRawTitle
        this.state.type = this.supportedTypes.includes(type) ? type : this.supportedTypes[0]

        // Add a little timeout for a better transition.
        setTimeout(() => {
            this.state.show = true
            this.startSelfDestructSequence()
        }, 100)
    }, 200),

    bell(title, text, useRawTitle = true, useRawText = true) {
        this.show('bell', title, text, useRawTitle, useRawText)
    },

    success(title, text, useRawTitle = false, useRawText = false) {
        this.show('success', title, text, useRawTitle, useRawText)
    },

    info(title, text, useRawTitle = false, useRawText = false) {
        this.show('info', title, text, useRawTitle, useRawText)
    },

    danger(title, text, useRawTitle = false, useRawText = false) {
        this.show('danger', title, text, useRawTitle, useRawText)
    },

    warning(title, text, useRawTitle = false, useRawText = false) {
        this.show('warning', title, text, useRawTitle, useRawText)
    },

    hide() {
        this.state.show = false
    },

    async showLatestNotification() {
    },

    startSelfDestructSequence() {
        clearTimeout(selfDestructTimer)
        selfDestructTimer = setTimeout(() => this.hide(), 9000)
    },
}
